import clsx from 'clsx'
import React, { useState } from 'react'
import Select, { SingleValue } from 'react-select'

import { formatIncrementTime, type ParsedTime } from '../schedulingUtils'

import {
  gapSelectStyles,
  SimpleOptionType,
} from '../../../../../customStyles/ReactSelectCustomStyle'

import { HOURS_OPTIONS, MINUTES_OPTIONS, SECONDS_OPTIONS } from '../../../../../fakeData/TimeList'

interface GapTimeSelectorProps {
  onTimeChange: (timeString: string) => void
  clashCount: number
}

const GapTimeSelector: React.FC<GapTimeSelectorProps> = ({ onTimeChange, clashCount }) => {
  const [selectedTime, setSelectedTime] = useState<ParsedTime>({ hour: '', minute: '', second: '' })

  const handleTimeChange = (
    type: 'hour' | 'minute' | 'second',
    option: SingleValue<{ value: string; label: string }>
  ) => {
    if (option) {
      const newSelectedTime = { ...selectedTime, [type]: option.value }
      setSelectedTime(newSelectedTime)

      // update parent
      const formattedTime = formatIncrementTime(
        newSelectedTime.hour,
        newSelectedTime.minute,
        newSelectedTime.second
      )
      onTimeChange(formattedTime)
    }
  }

  return (
    <div className="flex items-center rounded-lg border border-SeabiscuitGray500ThemeColor hover:border-SeabiscuitGray600ThemeColor px-2 gap-1 ">
      <div className="flex items-center ">
        <span className=" text-SeabiscuitDark200ThemeColor text-nr mr-2">Gap:</span>

        <Select
          classNamePrefix="select"
          options={HOURS_OPTIONS}
          value={HOURS_OPTIONS.find((h) => h.value === selectedTime.hour)}
          onChange={(opt) => handleTimeChange('hour', opt as SimpleOptionType)}
          styles={gapSelectStyles}
          isClearable={false}
          components={{ DropdownIndicator: null }}
          isSearchable={true}
          placeholder="00"
        />

        <span className="text-SeabiscuitDark200ThemeColor/50">:</span>

        <Select
          classNamePrefix="select"
          options={MINUTES_OPTIONS}
          value={MINUTES_OPTIONS.find((m) => m.value === selectedTime.minute)}
          onChange={(opt) => handleTimeChange('minute', opt as SimpleOptionType)}
          styles={gapSelectStyles}
          isClearable={false}
          components={{ DropdownIndicator: null }}
          isSearchable={true}
          placeholder="00"
        />

        <span className="text-SeabiscuitDark200ThemeColor/50">:</span>

        <Select
          classNamePrefix="select"
          options={SECONDS_OPTIONS}
          value={SECONDS_OPTIONS.find((s) => s.value === selectedTime.second)}
          onChange={(opt) => handleTimeChange('second', opt as SimpleOptionType)}
          styles={gapSelectStyles}
          isClearable={false}
          components={{ DropdownIndicator: null }}
          isSearchable={true}
          placeholder="00"
        />
      </div>

      {/* clash counter */}
      <div
        className={clsx(
          'text-nr px-2 py-1 text-center rounded-sm',
          clashCount > 0 ? 'bg-red-50' : 'bg-SeabiscuitGrayThemeColor'
        )}
      >
        <span
          className={clsx(clashCount > 0 ? 'text-red-600' : 'text-SeabiscuitDark200ThemeColor/50')}
        >
          {clashCount}
        </span>
      </div>
    </div>
  )
}

export default GapTimeSelector
